import { z } from 'zod';

export const WorkdayPostBody = z
  .object({
    base_date: z.string(),
    diff_days: z.number(),
  })
  .array();

export type WorkdayPostBody = z.infer<typeof WorkdayPostBody>;
